// AHA-46433 — two-level "My Files" menu (All / Presentations / Surveys) that
// replaces the Presentations sidebar branch.
export const MY_FILES_MENU_FLAG = 'AHA-46433-my-files-menu'

// Gate on the variant name, never on enabled/disabled: a boolean check cannot
// distinguish "control" from "the flag failed to load", and treating the latter as
// control corrupts the Mixpanel exposure split. Only an explicit TREATMENT opts a
// user into the new menu; every other value (including a missing flag, which
// getVariant reports as `disabled`) leaves them on the old Presentations branch.
export const MY_FILES_MENU_VARIANTS = {
  TREATMENT: 'treatment',
  CONTROL: 'control',
}
